<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

// Component Imports
import Button from '@/common/Button.vue'

// Define Props
const props = defineProps({
    viewId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed Properties
const listingName = computed(() => viewStore.listingName)
const pageSize = computed(() => viewStore.pageSize || 1)
const itemCount = computed(() => viewStore.itemCount || 0)
const page = computed(() => viewStore.page || 1)

const isLast = computed(() => {
    return page.value >= Math.ceil(itemCount.value / pageSize.value)
})

// Methods
const onClick = () => {
    if (!isLast.value) {
        viewStore.pageUp()
    }
}
</script>

<template>
    <Button :disabled="isLast" class="rounded-0" @click="onClick">
        <i class="bi-chevron-right"/>
    </Button>
</template>